import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { redirectsSelector } from '../modules/selectors/redirects';
import { findRedirectMatch, normalizePath } from './redirectMatcher';
import StandortRedirect from '../app/components/VHost/StandortRedirect';
import Status from '../app/components/Status/Status';

export default function RedirectCheck() {
  const location = useLocation();
  const redirects = useSelector(redirectsSelector);

  const match = findRedirectMatch(redirects, location);

  if (!match) return null;
  const rawNewUrl = match.newUrl;

  // external redirect
  if (
    typeof window !== 'undefined' &&
    rawNewUrl?.startsWith('http') &&
    !rawNewUrl.startsWith(window.location.origin)
  ) {
    window.location.replace(rawNewUrl);
    return null;
  }

  const currentPath =
    location.pathname + location.search + location.hash;

  const newPath = normalizePath(rawNewUrl);

  if (!newPath || newPath === currentPath) return null;

  return <Status code={match.statusCode}><StandortRedirect to={newPath} push /></Status>;
}